import { render, staticRenderFns } from "./HtFile.vue?vue&type=template&id=2b3b8b9b&scoped=true&"
import script from "./HtFile.vue?vue&type=script&lang=js&"
export * from "./HtFile.vue?vue&type=script&lang=js&"
import style0 from "./HtFile.vue?vue&type=style&index=0&id=2b3b8b9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b8b9b",
  null
  
)

export default component.exports